/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {TeamAppsUiComponentRegistry} from "../modules/TeamAppsUiComponentRegistry";
import {TeamAppsUiContext} from "../modules/TeamAppsUiContext";

export class CommandExecutor {
	private static commandExecutorsByCommandName: {[commandName: string]: (targetObject: any, command: any) => void} = {
		    'UiDummyComponent.displayMessage': (targetObject: any, command: any) => {
				targetObject.displayMessage(command.message);
			},
		    'UiVerticalLayout.addComponent': (targetObject: any, command: any) => {
				targetObject.addComponent(command.component);
			},
		    'UiVerticalLayout.removeComponent': (targetObject: any, command: any) => {
				targetObject.removeComponent(command.childId);
			},
		    'UiCalendar.setViewMode': (targetObject: any, command: any) => {
				targetObject.setViewMode(command.viewMode);
			},
		    'UiCalendar.setDisplayedDate': (targetObject: any, command: any) => {
				targetObject.setDisplayedDate(command.date);
			},
		    'UiCalendar.addEvent': (targetObject: any, command: any) => {
				targetObject.addEvent(command.theEvent);
			},
		    'UiCalendar.removeEvent': (targetObject: any, command: any) => {
				targetObject.removeEvent(command.eventId);
			},
		    'UiCalendar.setCalendarData': (targetObject: any, command: any) => {
				targetObject.setCalendarData(command.data, command.clearCalendar);
			},
		    'UiCalendar.clearCalendar': (targetObject: any, command: any) => {
				targetObject.clearCalendar();
			},
		    'UiLineChart.setData': (targetObject: any, command: any) => {
				targetObject.setData(command.data, command.clear);
			},
		    'UiContextMenu.hide': (targetObject: any, command: any) => {
				targetObject.hide();
			},
		    'UiDocumentViewer.setPageUrls': (targetObject: any, command: any) => {
				targetObject.setPageUrls(command.pageUrls);
			},
		    'UiDocumentViewer.setDisplayMode': (targetObject: any, command: any) => {
				targetObject.setDisplayMode(command.displayMode, command.zoomFactor);
			},
		    'UiDocumentViewer.setZoomFactor': (targetObject: any, command: any) => {
				targetObject.setZoomFactor(command.zoomFactor);
			},
		    'UiDocumentViewer.setPageBorder': (targetObject: any, command: any) => {
				targetObject.setPageBorder(command.pageBorder);
			},
		    'UiDocumentViewer.setPageShadow': (targetObject: any, command: any) => {
				targetObject.setPageShadow(command.pageShadow);
			},
		    'UiDocumentViewer.setPaddding': (targetObject: any, command: any) => {
				targetObject.setPaddding(command.padding);
			},
		    'UiDocumentViewer.setPageSpacing': (targetObject: any, command: any) => {
				targetObject.setPageSpacing(command.pageSpacing);
			},
		    'UiGauge.setOptions': (targetObject: any, command: any) => {
				targetObject.setOptions(command.options);
			},
		    'UiGauge.setValue': (targetObject: any, command: any) => {
				targetObject.setValue(command.value);
			},
		    'UiGridForm.setRecord': (targetObject: any, command: any) => {
				targetObject.setRecord(command.record, command.updateAllFields);
			},
		    'UiGridForm.submit': (targetObject: any, command: any) => {
				targetObject.submit();
			},
		    'UiGridForm.updateLayoutPolicies': (targetObject: any, command: any) => {
				targetObject.updateLayoutPolicies(command.layoutPolicies);
			},
		    'UiGridForm.setFieldEditingMode': (targetObject: any, command: any) => {
				targetObject.setFieldEditingMode(command.fieldName, command.editingMode);
			},
		    'UiGridForm.setSectionCollapsed': (targetObject: any, command: any) => {
				targetObject.setSectionCollapsed(command.sectionId, command.collapsed);
			},
		    'UiImageDisplay.setCachedImages': (targetObject: any, command: any) => {
				targetObject.setCachedImages(command.startIndex, command.cachedImages, command.totalNumberOfRecords);
			},
		    'UiImageDisplay.setDisplayMode': (targetObject: any, command: any) => {
				targetObject.setDisplayMode(command.displayMode, command.zoomFactor);
			},
		    'UiImageDisplay.setZoomFactor': (targetObject: any, command: any) => {
				targetObject.setZoomFactor(command.zoomFactor);
			},
		    'UiImageDisplay.showImage': (targetObject: any, command: any) => {
				targetObject.showImage(command.id);
			},
		    'UiImageCropper.setCroppedArea': (targetObject: any, command: any) => {
				targetObject.setCroppedArea(command.left, command.top, command.width, command.height);
			},
		    'UiInfiniteItemView.setData': (targetObject: any, command: any) => {
				targetObject.setData(command.startIndex, command.data, command.totalNumberOfRecords, command.clearTableCache);
			},
		    'UiInfiniteItemView.setItemTemplate': (targetObject: any, command: any) => {
				targetObject.setItemTemplate(command.itemTemplate);
			},
		    'UiInfiniteItemView.setItemWidth': (targetObject: any, command: any) => {
				targetObject.setItemWidth(command.itemWidth);
			},
		    'UiInfiniteItemView.setHorizontalItemMargin': (targetObject: any, command: any) => {
				targetObject.setHorizontalItemMargin(command.horizontalItemMargin);
			},
		    'UiInfiniteItemView.setItemJustification': (targetObject: any, command: any) => {
				targetObject.setItemJustification(command.itemJustification);
			},
		    'UiItemView.setFilter': (targetObject: any, command: any) => {
				targetObject.setFilter(command.filter);
			},
		    'UiItemView.addItemGroup': (targetObject: any, command: any) => {
				targetObject.addItemGroup(command.groupId, command.itemGroup);
			},
		    'UiItemView.refreshItemGroup': (targetObject: any, command: any) => {
				targetObject.refreshItemGroup(command.groupId, command.itemGroup);
			},
		    'UiItemView.removeItemGroup': (targetObject: any, command: any) => {
				targetObject.removeItemGroup(command.groupId);
			},
		    'UiItemView.addItem': (targetObject: any, command: any) => {
				targetObject.addItem(command.groupId, command.item);
			},
		    'UiItemView.removeItem': (targetObject: any, command: any) => {
				targetObject.removeItem(command.groupId, command.itemId);
			},
		    'UiItemView.selectItem': (targetObject: any, command: any) => {
				targetObject.selectItem(command.groupId, command.itemId);
			},
		    'UiApplicationLayout.setToolbar': (targetObject: any, command: any) => {
				targetObject.setToolbar(command.toolbar);
			},
		    'UiApplicationLayout.setRootSplitPane': (targetObject: any, command: any) => {
				targetObject.setRootSplitPane(command.splitPane);
			},
		    'UiMobileLayout.setToolbar': (targetObject: any, command: any) => {
				targetObject.setToolbar(command.toolbar);
			},
		    'UiMobileLayout.setNavigationBar': (targetObject: any, command: any) => {
				targetObject.setNavigationBar(command.navBar);
			},
		    'UiMobileLayout.addView': (targetObject: any, command: any) => {
				targetObject.addView(command.view);
			},
		    'UiMobileLayout.showView': (targetObject: any, command: any) => {
				targetObject.showView(command.viewId, command.animation);
			},
		    'UiMobileLayout.removeView': (targetObject: any, command: any) => {
				targetObject.removeView(command.viewId);
			},
		    'UiSplitPane.setFirstChild': (targetObject: any, command: any) => {
				targetObject.setFirstChild(command.firstChild);
			},
		    'UiSplitPane.setLastChild': (targetObject: any, command: any) => {
				targetObject.setLastChild(command.lastChild);
			},
		    'UiSplitPane.setSize': (targetObject: any, command: any) => {
				targetObject.setSize(command.referenceChildSize, command.sizePolicy);
			},
		    'UiAccordionLayout.addAccordionPanel': (targetObject: any, command: any) => {
				targetObject.addAccordionPanel(command.panel, command.neighborPanelId, command.beforeNeighbor);
			},
		    'UiAccordionLayout.addAccordionPanelContent': (targetObject: any, command: any) => {
				targetObject.addAccordionPanelContent(command.panelId, command.content);
			},
		    'UiAccordionLayout.removeAccordionPanel': (targetObject: any, command: any) => {
				targetObject.removeAccordionPanel(command.panelId);
			},
		    'UiAccordionLayout.removeAllPanels': (targetObject: any, command: any) => {
				targetObject.removeAllPanels();
			},
		    'UiAccordionLayout.selectPanel': (targetObject: any, command: any) => {
				targetObject.selectPanel(command.panelId);
			},
		    'UiAccordionLayout.setPanelOpen': (targetObject: any, command: any) => {
				targetObject.setPanelOpen(command.panelId, command.open);
			},
		    'UiLiveStreamComponent.showWaitingVideos': (targetObject: any, command: any) => {
				targetObject.showWaitingVideos(command.videoInfos, command.offsetSeconds, command.stopLiveStream);
			},
		    'UiLiveStreamComponent.stopWaitingVideos': (targetObject: any, command: any) => {
				targetObject.stopWaitingVideos();
			},
		    'UiLiveStreamComponent.startHttpLiveStream': (targetObject: any, command: any) => {
				targetObject.startHttpLiveStream(command.url);
			},
		    'UiLiveStreamComponent.startRtmpLiveStream': (targetObject: any, command: any) => {
				targetObject.startRtmpLiveStream(command.rtmpUrl, command.streamName);
			},
		    'UiLiveStreamComponent.startLiveStreamComLiveStream': (targetObject: any, command: any) => {
				targetObject.startLiveStreamComLiveStream(command.url);
			},
		    'UiLiveStreamComponent.startYouTubeLiveStream': (targetObject: any, command: any) => {
				targetObject.startYouTubeLiveStream(command.url);
			},
		    'UiLiveStreamComponent.startCustomEmbeddedLiveStreamPlayer': (targetObject: any, command: any) => {
				targetObject.startCustomEmbeddedLiveStreamPlayer(command.playerEmbedHtml, command.embedContainerId);
			},
		    'UiLiveStreamComponent.stopLiveStream': (targetObject: any, command: any) => {
				targetObject.stopLiveStream();
			},
		    'UiLiveStreamComponent.displayImageOverlay': (targetObject: any, command: any) => {
				targetObject.displayImageOverlay(command.imageUrl, command.displayMode, command.useVideoAreaAsFrame);
			},
		    'UiLiveStreamComponent.removeImageOverlay': (targetObject: any, command: any) => {
				targetObject.removeImageOverlay();
			},
		    'UiLiveStreamComponent.displayInfoTextOverlay': (targetObject: any, command: any) => {
				targetObject.displayInfoTextOverlay(command.text);
			},
		    'UiLiveStreamComponent.removeInfoTextOverlay': (targetObject: any, command: any) => {
				targetObject.removeInfoTextOverlay();
			},
		    'UiLiveStreamComponent.requestInputDeviceAccess': (targetObject: any, command: any) => {
				targetObject.requestInputDeviceAccess(command.microphone, command.camera);
			},
		    'UiLiveStreamComponent.requestInputDeviceInfo': (targetObject: any, command: any) => {
				targetObject.requestInputDeviceInfo();
			},
		    'UiLiveStreamComponent.publishStream': (targetObject: any, command: any) => {
				targetObject.publishStream(command.rtmpServerUrl, command.streamName, command.inputSettings);
			},
		    'UiLiveStreamComponent.unPublishStream': (targetObject: any, command: any) => {
				targetObject.unPublishStream();
			},
		    'UiLiveStreamComponent.setVolume': (targetObject: any, command: any) => {
				targetObject.setVolume(command.volume);
			},
		    'UiLiveStreamComponent.getFlashPlayerVersion': (targetObject: any, command: any) => {
				targetObject.getFlashPlayerVersion();
			},
		    'UiWebRtcPublisher.publish': (targetObject: any, command: any) => {
				targetObject.publish(command.webSocketUrl, command.wowzaApplicationName, command.streamName, command.inputSettings, command.showLocalVideo);
			},
		    'UiWebRtcPublisher.unPublish': (targetObject: any, command: any) => {
				targetObject.unPublish();
			},
		    'UiWebRtcPublisher.play': (targetObject: any, command: any) => {
				targetObject.play(command.webSocketUrl, command.wowzaApplicationName, command.streamName);
			},
		    'UiWebRtcPublisher.stopPlaying': (targetObject: any, command: any) => {
				targetObject.stopPlaying();
			},
		    'AbstractUiLiveStreamPlayer.play': (targetObject: any, command: any) => {
				targetObject.play(command.url, command.streamName);
			},
		    'AbstractUiLiveStreamPlayer.stop': (targetObject: any, command: any) => {
				targetObject.stop();
			},
		    'AbstractUiLiveStreamPlayer.setVolume': (targetObject: any, command: any) => {
				targetObject.setVolume(command.volume);
			},
		    'UiRtmpLiveStreamPlayer.getFlashPlayerVersion': (targetObject: any, command: any) => {
				targetObject.getFlashPlayerVersion();
			},
		    'UiMap.addMarker': (targetObject: any, command: any) => {
				targetObject.addMarker(command.marker);
			},
		    'UiMap.addPolyline': (targetObject: any, command: any) => {
				targetObject.addPolyline(command.lineId, command.polyline);
			},
		    'UiMap.addPolylinePoints': (targetObject: any, command: any) => {
				targetObject.addPolylinePoints(command.lineId, command.points);
			},
		    'UiMap.removePolyline': (targetObject: any, command: any) => {
				targetObject.removePolyline(command.lineId);
			},
		    'UiMap.setZoomLevel': (targetObject: any, command: any) => {
				targetObject.setZoomLevel(command.zoom);
			},
		    'UiMap.setLocation': (targetObject: any, command: any) => {
				targetObject.setLocation(command.location);
			},
		    'UiMap.setMapType': (targetObject: any, command: any) => {
				targetObject.setMapType(command.mapType);
			},
		    'UiMap.setMapMarkerCluster': (targetObject: any, command: any) => {
				targetObject.setMapMarkerCluster(command.cluster);
			},
		    'UiMap.setHeatMap': (targetObject: any, command: any) => {
				targetObject.setHeatMap(command.data);
			},
		    'UiMediaTrackGraph.setCursorPosition': (targetObject: any, command: any) => {
				targetObject.setCursorPosition(command.time);
			},
		    'UiVideoPlayer.setUrl': (targetObject: any, command: any) => {
				targetObject.setUrl(command.url);
			},
		    'UiVideoPlayer.play': (targetObject: any, command: any) => {
				targetObject.play();
			},
		    'UiVideoPlayer.pause': (targetObject: any, command: any) => {
				targetObject.pause();
			},
		    'UiVideoPlayer.jumpTo': (targetObject: any, command: any) => {
				targetObject.jumpTo(command.timeInSeconds);
			},
		    'UiNavigationBar.addButton': (targetObject: any, command: any) => {
				targetObject.addButton(command.button, command.neighborButtonId, command.beforeNeighbor);
			},
		    'UiNavigationBar.removeButton': (targetObject: any, command: any) => {
				targetObject.removeButton(command.buttonId);
			},
		    'UiNavigationBar.setButtonVisible': (targetObject: any, command: any) => {
				targetObject.setButtonVisible(command.buttonId, command.visible);
			},
		    'UiNavigationBar.addFanOutComponent': (targetObject: any, command: any) => {
				targetObject.addFanOutComponent(command.fanOutComponent);
			},
		    'UiNavigationBar.removeFanOutComponent': (targetObject: any, command: any) => {
				targetObject.removeFanOutComponent(command.fanOutComponentId);
			},
		    'UiNavigationBar.showFanOutComponent': (targetObject: any, command: any) => {
				targetObject.showFanOutComponent(command.fanOutComponentId);
			},
		    'UiNavigationBar.hideFanOutComponent': (targetObject: any, command: any) => {
				targetObject.hideFanOutComponent();
			},
		    'UiNetworkGraph.setZoomFactor': (targetObject: any, command: any) => {
				targetObject.setZoomFactor(command.zoomFactor);
			},
		    'UiNetworkGraph.setGravity': (targetObject: any, command: any) => {
				targetObject.setGravity(command.gravity);
			},
		    'UiNetworkGraph.setCharge': (targetObject: any, command: any) => {
				targetObject.setCharge(command.charge, command.overrideNodeCharge);
			},
		    'UiNetworkGraph.setDistance': (targetObject: any, command: any) => {
				targetObject.setDistance(command.distance, command.overrideLinkDistance);
			},
		    'UiPageView.addBlock': (targetObject: any, command: any) => {
				targetObject.addBlock(command.block, command.before, command.otherBlockId);
			},
		    'UiPageView.removeBlock': (targetObject: any, command: any) => {
				targetObject.removeBlock(command.blockId);
			},
		    'UiPanel.setContent': (targetObject: any, command: any) => {
				targetObject.setContent(command.content);
			},
		    'UiPanel.setLeftHeaderField': (targetObject: any, command: any) => {
				targetObject.setLeftHeaderField(command.field);
			},
		    'UiPanel.setRightHeaderField': (targetObject: any, command: any) => {
				targetObject.setRightHeaderField(command.field);
			},
		    'UiPanel.setTitle': (targetObject: any, command: any) => {
				targetObject.setTitle(command.title);
			},
		    'UiPanel.setIcon': (targetObject: any, command: any) => {
				targetObject.setIcon(command.icon);
			},
		    'UiPanel.setToolbar': (targetObject: any, command: any) => {
				targetObject.setToolbar(command.toolbar);
			},
		    'UiPanel.setMaximizable': (targetObject: any, command: any) => {
				targetObject.setMaximizable(command.maximizable);
			},
		    'UiPanel.setMaximized': (targetObject: any, command: any) => {
				targetObject.setMaximized(command.maximized);
			},
		    'UiPanel.setToolButtons': (targetObject: any, command: any) => {
				targetObject.setToolButtons(command.toolButtons);
			},
		    'UiPanel.showToolButtonDropDown': (targetObject: any, command: any) => {
				targetObject.showToolButtonDropDown(command.toolButtonId, command.dropDownItemView, command.dropDownWidth);
			},
		    'UiWindow.close': (targetObject: any, command: any) => {
				targetObject.close(command.animationDuration);
			},
		    'UiWindow.setCloseable': (targetObject: any, command: any) => {
				targetObject.setCloseable(command.closeable);
			},
		    'UiWindow.setCloseOnEscape': (targetObject: any, command: any) => {
				targetObject.setCloseOnEscape(command.closeOnEscape);
			},
		    'UiWindow.setCloseOnClickOutside': (targetObject: any, command: any) => {
				targetObject.setCloseOnClickOutside(command.closeOnClickOutside);
			},
		    'UiWindow.setModal': (targetObject: any, command: any) => {
				targetObject.setModal(command.modal);
			},
		    'UiWindow.setModalBackgroundDimmingColor': (targetObject: any, command: any) => {
				targetObject.setModalBackgroundDimmingColor(command.modalBackgroundDimmingColor);
			},
		    'UiWindow.setSize': (targetObject: any, command: any) => {
				targetObject.setSize(command.width, command.height);
			},
		    'UiElegantPanel.setContent': (targetObject: any, command: any) => {
				targetObject.setContent(command.content);
			},
		    'UiRootPanel.addChildComponent': (targetObject: any, command: any) => {
				targetObject.addChildComponent(command.childComponent, command.show);
			},
		    'UiRootPanel.setVisibleChildComponent': (targetObject: any, command: any) => {
				targetObject.setVisibleChildComponent(command.childComponentId, command.animation, command.animationDuration);
			},
		    'UiRootPanel.removeChildComponent': (targetObject: any, command: any) => {
				targetObject.removeChildComponent(command.childComponentId);
			},
		    'UiTable.clearTable': (targetObject: any, command: any) => {
				targetObject.clearTable();
			},
		    'UiTable.removeRow': (targetObject: any, command: any) => {
				targetObject.removeRow(command.recordId);
			},
		    'UiTable.setTableData': (targetObject: any, command: any) => {
				targetObject.setTableData(command.startIndex, command.data, command.totalNumberOfRecords, command.sortField, command.sortDirection, command.clearTableCache);
			},
		    'UiTable.setChildrenData': (targetObject: any, command: any) => {
				targetObject.setChildrenData(command.parentRecordId, command.data);
			},
		    'UiTable.markTableField': (targetObject: any, command: any) => {
				targetObject.markTableField(command.recordId, command.fieldName, command.mark);
			},
		    'UiTable.clearAllFieldMarkings': (targetObject: any, command: any) => {
				targetObject.clearAllFieldMarkings();
			},
		    'UiTable.setRecordBold': (targetObject: any, command: any) => {
				targetObject.setRecordBold(command.recordId, command.bold);
			},
		    'UiTable.selectSingleRow': (targetObject: any, command: any) => {
				targetObject.selectSingleRow(command.recordId, command.scrollToRecord);
			},
		    'UiTable.setHeaderData': (targetObject: any, command: any) => {
				targetObject.setHeaderData(command.data);
			},
		    'UiTable.setHeaderFieldValue': (targetObject: any, command: any) => {
				targetObject.setHeaderFieldValue(command.fieldName, command.value);
			},
		    'UiTable.focusHeaderField': (targetObject: any, command: any) => {
				targetObject.focusHeaderField(command.fieldName);
			},
		    'UiTable.invokeOnHeaderField': (targetObject: any, command: any) => {
				targetObject.invokeOnHeaderField(command.fieldName, command.fieldCommand);
			},
		    'UiTable.setFooterData': (targetObject: any, command: any) => {
				targetObject.setFooterData(command.data);
			},
		    'UiTable.setFooterFieldValue': (targetObject: any, command: any) => {
				targetObject.setFooterFieldValue(command.fieldName, command.value);
			},
		    'UiTable.focusFooterField': (targetObject: any, command: any) => {
				targetObject.focusFooterField(command.fieldName);
			},
		    'UiTable.invokeOnFooterField': (targetObject: any, command: any) => {
				targetObject.invokeOnFooterField(command.fieldName, command.fieldCommand);
			},
		    'UiTabPanel.setHideTabBarIfSingleTab': (targetObject: any, command: any) => {
				targetObject.setHideTabBarIfSingleTab(command.hideTabBarIfSingleTab);
			},
		    'UiTabPanel.setTabStyle': (targetObject: any, command: any) => {
				targetObject.setTabStyle(command.tabStyle);
			},
		    'UiTabPanel.setToolButtons': (targetObject: any, command: any) => {
				targetObject.setToolButtons(command.toolButtons);
			},
		    'UiTabPanel.selectTab': (targetObject: any, command: any) => {
				targetObject.selectTab(command.tabId, command.sendSelectionEvent);
			},
		    'UiTabPanel.addTab': (targetObject: any, command: any) => {
				targetObject.addTab(command.tab, command.select, command.sendSelectionEvent);
			},
		    'UiTabPanel.removeTab': (targetObject: any, command: any) => {
				targetObject.removeTab(command.tabId);
			},
		    'UiTabPanel.showToolButtonDropDown': (targetObject: any, command: any) => {
				targetObject.showToolButtonDropDown(command.toolButtonId, command.dropDownItemView, command.dropDownWidth);
			},
		    'UiTabPanel.setTabToolbar': (targetObject: any, command: any) => {
				targetObject.setTabToolbar(command.tabId, command.toolbar);
			},
		    'UiTabPanel.setTabContent': (targetObject: any, command: any) => {
				targetObject.setTabContent(command.tabId, command.component);
			},
		    'UiTabPanel.setTabConfiguration': (targetObject: any, command: any) => {
				targetObject.setTabConfiguration(command.tabId, command.icon, command.caption, command.closeable, command.rightSide);
			},
		    'UiTimeGraph.setIntervalX': (targetObject: any, command: any) => {
				targetObject.setIntervalX(command.intervalX);
			},
		    'UiTimeGraph.setIntervalY': (targetObject: any, command: any) => {
				targetObject.setIntervalY(command.intervalY);
			},
		    'UiTimeGraph.setMaxPixelsBetweenDataPoints': (targetObject: any, command: any) => {
				targetObject.setMaxPixelsBetweenDataPoints(command.maxPixelsBetweenDataPoints);
			},
		    'UiTimeGraph.setYScaleType': (targetObject: any, command: any) => {
				targetObject.setYScaleType(command.yScaleType);
			},
		    'UiTimeGraph.addData': (targetObject: any, command: any) => {
				targetObject.addData(command.zoomLevel, command.intervalX, command.data);
			},
		    'UiTimeGraph.resetAllData': (targetObject: any, command: any) => {
				targetObject.resetAllData();
			},
		    'UiTimeGraph.replaceAllData': (targetObject: any, command: any) => {
				targetObject.replaceAllData(command.zoomLevel, command.intervalX, command.data);
			},
		    'UiTimeGraph.setYScaleZoomMode': (targetObject: any, command: any) => {
				targetObject.setYScaleZoomMode(command.yScaleZoomMode);
			},
		    'UiTimeGraph.setMouseScrollZoomPanMode': (targetObject: any, command: any) => {
				targetObject.setMouseScrollZoomPanMode(command.mouseScrollZoomPanMode);
			},
		    'UiTimeGraph.setSelectedInterval': (targetObject: any, command: any) => {
				targetObject.setSelectedInterval(command.intervalX);
			},
		    'UiTimeGraph.setLineFormats': (targetObject: any, command: any) => {
				targetObject.setLineFormats(command.lineFormats);
			},
		    'AbstractUiToolContainer.setButtonVisible': (targetObject: any, command: any) => {
				targetObject.setButtonVisible(command.buttonId, command.visible);
			},
		    'AbstractUiToolContainer.setButtonGroupVisible': (targetObject: any, command: any) => {
				targetObject.setButtonGroupVisible(command.groupId, command.visible);
			},
		    'AbstractUiToolContainer.addButton': (targetObject: any, command: any) => {
				targetObject.addButton(command.groupId, command.button, command.neighborButtonId, command.beforeNeighbor);
			},
		    'AbstractUiToolContainer.removeButton': (targetObject: any, command: any) => {
				targetObject.removeButton(command.buttonId);
			},
		    'AbstractUiToolContainer.addButtonGroup': (targetObject: any, command: any) => {
				targetObject.addButtonGroup(command.group);
			},
		    'AbstractUiToolContainer.removeButtonGroup': (targetObject: any, command: any) => {
				targetObject.removeButtonGroup(command.groupId);
			},
		    'AbstractUiToolContainer.setDropDownData': (targetObject: any, command: any) => {
				targetObject.setDropDownData(command.buttonId, command.itemView);
			},
		    'AbstractUiToolContainer.updateButtonGroups': (targetObject: any, command: any) => {
				targetObject.updateButtonGroups(command.buttonGroups);
			},
		    'UiToolbar.setLogoImage': (targetObject: any, command: any) => {
				targetObject.setLogoImage(command.logoImage);
			},
		    'UiTree.setData': (targetObject: any, command: any) => {
				targetObject.setData(command.treeData);
			},
		    'UiTree.setChildren': (targetObject: any, command: any) => {
				targetObject.setChildren(command.parentId, command.children);
			},
		    'UiTree.addOrUpdateNode': (targetObject: any, command: any) => {
				targetObject.addOrUpdateNode(command.node);
			},
		    'UiTree.relocateNode': (targetObject: any, command: any) => {
				targetObject.relocateNode(command.recordId, command.newParentRecordId);
			},
		    'UiTree.removeNode': (targetObject: any, command: any) => {
				targetObject.removeNode(command.recordId);
			},
		    'UiTree.removeAllNodes': (targetObject: any, command: any) => {
				targetObject.removeAllNodes();
			},
		    'UiTree.selectNode': (targetObject: any, command: any) => {
				targetObject.selectNode(command.recordId);
			},
		    'UiWorkSpaceLayout.setToolbar': (targetObject: any, command: any) => {
				targetObject.setToolbar(command.toolbar);
			},
		    'UiWorkSpaceLayout.addViewAsTab': (targetObject: any, command: any) => {
				targetObject.addViewAsTab(command.newView, command.existingViewName, command.select);
			},
		    'UiWorkSpaceLayout.addViewRelativeToOtherView': (targetObject: any, command: any) => {
				targetObject.addViewRelativeToOtherView(command.newView, command.existingViewName, command.relativePosition, command.sizePolicy, command.referenceChildSize);
			},
		    'UiWorkSpaceLayout.addViewToTopLevel': (targetObject: any, command: any) => {
				targetObject.addViewToTopLevel(command.newView, command.windowId, command.relativePosition, command.sizePolicy, command.referenceChildSize);
			},
		    'UiWorkSpaceLayout.moveViewToTab': (targetObject: any, command: any) => {
				targetObject.moveViewToTab(command.viewName, command.existingViewName, command.select);
			},
		    'UiWorkSpaceLayout.moveViewRelativeToOtherView': (targetObject: any, command: any) => {
				targetObject.moveViewRelativeToOtherView(command.viewName, command.existingViewName, command.relativePosition, command.sizePolicy, command.referenceChildSize);
			},
		    'UiWorkSpaceLayout.moveViewToTopLevel': (targetObject: any, command: any) => {
				targetObject.moveViewToTopLevel(command.viewName, command.windowId, command.relativePosition, command.sizePolicy, command.referenceChildSize);
			},
		    'UiWorkSpaceLayout.redefineLayout': (targetObject: any, command: any) => {
				targetObject.redefineLayout(command.windowId, command.newLayout);
			},
		    'UiWorkSpaceLayout.removeView': (targetObject: any, command: any) => {
				targetObject.removeView(command.viewName);
			},
		    'UiWorkSpaceLayout.refreshView': (targetObject: any, command: any) => {
				targetObject.refreshView(command.viewName, command.component, command.tabIcon, command.tabCaption, command.tabCloseable);
			},
		    'UiWorkSpaceLayout.refreshViewComponent': (targetObject: any, command: any) => {
				targetObject.refreshViewComponent(command.viewName, command.component);
			},
		    'UiWorkSpaceLayout.selectViewTab': (targetObject: any, command: any) => {
				targetObject.selectViewTab(command.viewName);
			},
		    'UiSingleRecordFieldContainer.setFieldValue': (targetObject: any, command: any) => {
				targetObject.setFieldValue(command.fieldName, command.value);
			},
		    'UiSingleRecordFieldContainer.setFieldVisible': (targetObject: any, command: any) => {
				targetObject.setFieldVisible(command.fieldName, command.visible);
			},
		    'UiSingleRecordFieldContainer.focusField': (targetObject: any, command: any) => {
				targetObject.focusField(command.fieldName);
			},
		    'UiSingleRecordFieldContainer.invokeOnField': (targetObject: any, command: any) => {
				targetObject.invokeOnField(command.fieldName, command.fieldCommand);
			},
		    'UiMultiRecordFieldContainer.setFieldValue': (targetObject: any, command: any) => {
				targetObject.setFieldValue(command.recordId, command.fieldName, command.value);
			},
		    'UiMultiRecordFieldContainer.setFieldVisible': (targetObject: any, command: any) => {
				targetObject.setFieldVisible(command.fieldName, command.visible);
			},
		    'UiMultiRecordFieldContainer.focusField': (targetObject: any, command: any) => {
				targetObject.focusField(command.recordId, command.fieldName);
			},
		    'UiMultiRecordFieldContainer.invokeOnField': (targetObject: any, command: any) => {
				targetObject.invokeOnField(command.fieldName, command.fieldCommand);
			},
		    'UiMultiRecordFieldContainer.invokeOnFieldIfActive': (targetObject: any, command: any) => {
				targetObject.invokeOnFieldIfActive(command.recordId, command.fieldName, command.fieldCommand);
			}
	};

	private static staticCommandExecutorsByCommandName: {[commandName: string]: (command: any, context: TeamAppsUiContext) => void} = {
		    'UiRootPanel.showWindow': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).showWindow(command.window, command.animationDuration, context);
			},
		    'UiRootPanel.closeWindow': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).closeWindow(command.windowId, command.animationDuration, context);
			},
		    'UiRootPanel.buildRootPanel': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).buildRootPanel(command.containerElementId, command.uiRootPanel, context);
			},
		    'UiRootPanel.downloadFile': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).downloadFile(command.fileUrl, command.downloadFileName, context);
			},
		    'UiRootPanel.setConfig': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).setConfig(command.config, context);
			},
		    'UiRootPanel.registerBackgroundImage': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).registerBackgroundImage(command.id, command.image, command.blurredImage, context);
			},
		    'UiRootPanel.setBackgroundImage': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).setBackgroundImage(command.id, command.animationDuration, context);
			},
		    'UiRootPanel.exitFullScreen': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).exitFullScreen(context);
			},
		    'UiRootPanel.setTheme': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).setTheme(command.theme, context);
			},
		    'UiRootPanel.registerTemplate': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).registerTemplate(command.id, command.template, context);
			},
		    'UiRootPanel.registerTemplates': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).registerTemplates(command.templates, context);
			},
		    'UiRootPanel.addClientToken': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).addClientToken(command.token, context);
			},
		    'UiRootPanel.removeClientToken': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).removeClientToken(command.token, context);
			},
		    'UiRootPanel.clearClientTokens': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).clearClientTokens(context);
			},
		    'UiRootPanel.showNotification': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).showNotification(command.notification, context);
			},
		    'UiRootPanel.showDialogMessage': (command: any, context: TeamAppsUiContext) => {
				(TeamAppsUiComponentRegistry.getComponentClassForName("UiRootPanel") as any).showDialogMessage(command.icon, command.title, command.message, command.options, context);
			}
	};

	public static executeCommand(targetObject: any, command: any) {
		this.commandExecutorsByCommandName[command._type](targetObject, command);
	}

	public static executeStaticCommand(command: any, context: TeamAppsUiContext) {
		this.staticCommandExecutorsByCommandName[command._type](command, context);
	}
}